import { axiosInstance as axios } from '../lib/axios'
import { NATIONAL_PROMOTION_AVAILABLE } from '../actionTypes/nationalPromotion'
import { isNationalPromotionMockEnabled } from '../views/NationalPromotionListPage/hooks/nationalPromotionMock'

// REV-1872: POST /national-promotion/available responde se ALGUM dos postos
// participa de promoção nacional ativa ({ success: boolean }). Controla a
// exibição do item "Promoção Nacional" nos menus. Falha de rede = oculto.
export const getNationalPromotionAvailable = (storeIds) => async (dispatch) => {
  const dispatchAvailable = (available) =>
    dispatch({ type: NATIONAL_PROMOTION_AVAILABLE, payload: available })

  if (isNationalPromotionMockEnabled()) {
    dispatchAvailable(true)
    return
  }

  if (!Array.isArray(storeIds) || storeIds.length === 0) {
    dispatchAvailable(false)
    return
  }

  try {
    const { data } = await axios.post('/national-promotion/available', { store_ids: storeIds })
    dispatchAvailable(data?.success === true)
  } catch (error) {
    dispatchAvailable(false)
  }
}
